import * as React from 'react';
import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useDispatch, useSelector } from 'react-redux';
import Grid from '@mui/material/Grid';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import IconButton from '@mui/material/IconButton';
import ListItemText from '@mui/material/ListItemText';
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';
import EditRoundedIcon from '@mui/icons-material/EditRounded';
import Divider from '@mui/material/Divider';
import { workspaceActions } from '../../../WorkspaceActions';

interface TemplatesListProps {
    handleClose: () => void;
    setEditTemplate: (template: any) => void;
    area: string;
}

const TemplatesList: React.FC<TemplatesListProps> = ({
    handleClose,
    setEditTemplate,
    area,
}) => {
    const dispatch = useDispatch();
    const savedFilterConfiguration = useSelector(
        (state: any) =>
            state.workspace && state.workspace['saved-filters-configuration']
    );

    const handleCancel = () => {
        handleClose();
    };

    const handleRemoveTemplate = (name: string) => {
        const filteredList = savedFilterConfiguration.filter((item: any) => {
            return item.name !== name;
        });

        dispatch(
            workspaceActions?.setWorkspaceConfiguration(
                area,
                'saved-filters-configuration',
                filteredList
            )
        );
    };

    const handleEditTemplate = (template: any) => {
        setEditTemplate(template);
    };

    return (
        <div>
            <DialogTitle>Manage Saved Filter Template</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Manage your saved filter templates here to edit or remove
                    them as needed. By doing so, you ensure that your filter
                    combinations remain relevant and up-to-date.
                </DialogContentText>
            </DialogContent>
            <DialogContent>
                <Grid item xs={12}>
                    <List>
                        {savedFilterConfiguration &&
                            savedFilterConfiguration.length > 0 &&
                            savedFilterConfiguration.map(
                                (template: any, i: number) => {
                                    return (
                                        <div key={`filter_template_${i}`}>
                                            <ListItem
                                                secondaryAction={
                                                    <Grid
                                                        container
                                                        direction={'row'}
                                                        spacing={2}
                                                        justifyContent="center"
                                                        alignItems="center"
                                                    >
                                                        <Grid item>
                                                            <IconButton
                                                                aria-label="edit"
                                                                onClick={() =>
                                                                    handleEditTemplate(
                                                                        template
                                                                    )
                                                                }
                                                            >
                                                                <EditRoundedIcon />
                                                            </IconButton>
                                                        </Grid>
                                                        <Grid item>
                                                            <Divider
                                                                orientation="vertical"
                                                                flexItem
                                                                style={{
                                                                    height: 25,
                                                                }}
                                                            />
                                                        </Grid>
                                                        <Grid item>
                                                            <IconButton
                                                                edge="end"
                                                                aria-label="delete"
                                                                onClick={() =>
                                                                    handleRemoveTemplate(
                                                                        template.name
                                                                    )
                                                                }
                                                            >
                                                                <DeleteRoundedIcon />
                                                            </IconButton>
                                                        </Grid>
                                                    </Grid>
                                                }
                                            >
                                                <ListItemText
                                                    primary={template.name}
                                                />
                                            </ListItem>
                                            <Divider
                                                flexItem
                                                sx={{ opacity: 0.2 }}
                                            />
                                        </div>
                                    );
                                }
                            )}
                    </List>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCancel}>Cancel</Button>
                <Button onClick={handleCancel} variant={'contained'}>
                    Done
                </Button>
            </DialogActions>
        </div>
    );
};

export default TemplatesList;
